module.exports = __webpack_public_path__ + "img/img18.c7b54753.png";